/* eslint-disable consistent-return */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from 'translations/en.json'
import es from 'translations/es.json'
import fr from 'translations/fr.json'
import de from 'translations/de.json'
import it from 'translations/it.json'
import { format as formatDate, isDate } from 'date-fns'
import {
  enGB,
  es as esESP,
  frCH,
  de as deCH,
  it as itCH,
} from 'date-fns/locale'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import languageOptions from './languages'

export const dateLocales = { en: enGB, es: esESP, fr: frCH, de: deCH, it: itCH }

export const availableLanguages = languageOptions.map((item) => item.value)
i18n
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it },
    },
    supportedLngs: availableLanguages,
    debug: false,
    fallbackLng: 'en',
    preload: ['en'],
    detection: {
      order: ['querystring', 'cookie', 'header'],
      lookupCookie: 'lang',
      lookupQuerystring: 'lang',
      caches: ['cookie'],
      cookieMinutes: 525600,
    },
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (isDate(value) && format) {
          const locale = dateLocales[lng as keyof typeof dateLocales]
          return formatDate(value, format, { locale })
        }
        return ''
      },
    },
    react: { useSuspense: false },
  })

document.documentElement.lang = i18n.language

export default i18n
